<script>
import EventSelectionOddsRow from './EventSelectionOddsRow.vue';
import AreaChart from '../../MarketMover/common/AreaChart.vue';
import Tooltip from '../../Tooltip/Tooltip.vue';
import Moment from 'moment';
export default {
  name: 'EventSelectionModalOdds',
  components: {
    EventSelectionOddsRow,
    AreaChart,
    Tooltip,
  },
  props: {
    selectionWinOdds: {
      type: Array,
      default: () => [],
    },
    selectionPlaceOdds: {
      type: Array,
      default: () => [],
    },
    winFlucs: {
      type: Array,
      required: true,
      default: () => [],
    },
    placeFlucs: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => {
    return {
      tooltip: {
        price: 0,
        updatedAt: '',
        isShow: false,
        x: 0,
      },
      tooltipPosition: {
        x: 0,
      },
      widthThreshold: window.innerWidth - 45,
      winActive: true,
      placeActive: false,
    };
  },
  computed: {
    activeFlucs() {
      const { winActive, winFlucs, placeFlucs } = this;
      return winActive ? winFlucs : placeFlucs;
    },
    // set the position of tooltip
    position() {
      const { widthThreshold } = this;
      const { x } = this.tooltip;
      // left align tooltip
      if (x == 0) {
        return { left: 0 };
      }
      // right align tooltip
      if (x > widthThreshold) {
        return { right: 0 };
      }
      // center align tooltip
      return { left: `calc(${x}px - 40px)` };
    },
  },
  methods: {
    formatTimestamp: function(timestamp) {
      return Moment(timestamp).format('MMM DD, hh:mm a');
    },
    showTooltip: function(data) {
      this.tooltip = {
        isShow: true,
        price: data.value,
        updatedAt: this.formatTimestamp(data.updatedAt),
        x: data.position,
      };
    },
    hideTooltip: function() {
      this.tooltip.isShow = false;
    },
    toggleBetType(type) {
      if (type === 'win') {
        this.winActive = true;
        this.placeActive = false;
      }
      if (type === 'place') {
        this.winActive = false;
        this.placeActive = true;
      }
    },
  },
};
</script>

<template>
  <div class="event-selection-modal-odds">
    <!-- tooltip -->
    <template v-if="activeFlucs.length > 0">
      <div
        :style="position"
        :class="{'tooltip-active' : tooltip.isShow, 'left-align': tooltip.x == 0, 'right-align': tooltip.x > widthThreshold }"
        class="event-selection-modal-odds__tooltip"
      >
        <div class="event-selection-modal-odds__tooltip-header">{{ tooltip.updatedAt }}</div>
        <div class="event-selection-modal-odds__tooltip-details">${{ tooltip.price }}</div>
      </div>

      <!-- win/place toggle buttons -->
      <div class="event-selection-modal-odds__right-btns">
        <div class="event-selection-modal-odds__btn-container">
          <a
            :class="[{ active: winActive }]"
            class="event-selection-modal-odds__btn"
            href="#"
            @click.prevent="toggleBetType('win')"
          >
            <p>Win</p>
          </a>
          <a
            :class="[{ active: placeActive }]"
            class="event-selection-modal-odds__btn"
            href="#"
            @click.prevent="toggleBetType('place')"
          >
            <p>Place</p>
          </a>
        </div>
      </div>

      <!-- flucs chart -->
      <div :key="`flucs-chart-${winActive}`" class="event-selection-modal-odds__flucs">
        <template v-if="activeFlucs.length > 1">
          <AreaChart
            :points="activeFlucs"
            :chart-height="170"
            :show-grid-lines="false"
            @show-tooltip="showTooltip"
            @hide-tooltip="hideTooltip"
          />
        </template>
        <template v-else>
          <div class="event-selection-modal-odds__no-move">No Movement</div>
        </template>
      </div>
    </template>

    <!-- selection odds -->
    <template v-if="winActive && selectionWinOdds.length > 0">
      <EventSelectionOddsRow
        v-for="(selection, index) in selectionWinOdds"
        :key="`win-${index}`"
        :selection-odds="selection"
      />
    </template>
    <template v-if="placeActive && selectionPlaceOdds.length > 0">
      <EventSelectionOddsRow
        v-for="(selection, index) in selectionPlaceOdds"
        :key="`place-${index}`"
        :selection-odds="selection"
      />
    </template>
  </div>
</template>
